/**
 * ArenaStats - Insights Service
 * Motor editorial da rede social - dados analíticos de natação
 */

import { AZURE } from './api';

/**
 * 1. DESTAQUES DA SEMANA (Hero Cards)
 * Retorna recordes, campeões e performances elite
 */
export const getWeeklyHighlights = async (params = {}) => {
  try {
    const { sport = 'natacao', limit = 6, gender } = params;
    const response = await AZURE.get('/insights/weekly-highlights', {
      params: { sport, limit, gender }
    });
    return response.data;
  } catch (error) {
    console.error('[InsightsService] Error fetching weekly highlights:', error);
    throw error;
  }
};

/**
 * 2. PROGRESSÃO DE RECORDES (WR/CR Timeline)
 * Linha do tempo de recordes para um evento específico
 */
export const getRecordProgression = async (params = {}) => {
  try {
    const { event_id, distance, stroke, gender } = params;
    
    if (!event_id && (!distance || !stroke || !gender)) {
      throw new Error('Provide event_id OR (distance + stroke + gender)');
    }
    
    const response = await AZURE.get('/insights/record-progression', {
      params: { event_id, distance, stroke, gender }
    });
    return response.data;
  } catch (error) {
    console.error('[InsightsService] Error fetching record progression:', error);
    throw error;
  }
};

/**
 * 3. ANÁLISE DE DOMINÂNCIA (Winner vs Field)
 * Compara vencedor com média e desvio padrão do campo
 */
export const getDominanceAnalysis = async (params = {}) => {
  try {
    const { competition_id, event_id, limit = 20 } = params;
    const response = await AZURE.get('/insights/dominance-analysis', {
      params: { competition_id, event_id, limit }
    });
    return response.data;
  } catch (error) {
    console.error('[InsightsService] Error fetching dominance analysis:', error);
    throw error;
  }
};

/**
 * 4. ANÁLISE DE REVEZAMENTO (Flying vs Flat Start)
 * Correção de relay takeover vs tempo individual
 */
export const getRelayCorrection = async (params = {}) => {
  try {
    const { swimmer_id, competition_id, limit = 10 } = params;
    const response = await AZURE.get('/insights/relay-correction', {
      params: { swimmer_id, competition_id, limit }
    });
    return response.data;
  } catch (error) {
    console.error('[InsightsService] Error fetching relay correction:', error);
    throw error;
  }
};

/**
 * 5. CREATOR SPOTLIGHT (Futuro)
 * Conteúdo criado pela comunidade
 */
export const getCreatorSpotlight = async (params = {}) => {
  try {
    const { limit = 10 } = params;
    const response = await AZURE.get('/insights/creator-spotlight', {
      params: { limit }
    });
    return response.data;
  } catch (error) {
    console.error('[InsightsService] Error fetching creator spotlight:', error);
    throw error;
  }
};

/**
 * HELPER: Health Check da API de Insights
 */
export const healthCheck = async () => {
  try {
    const response = await AZURE.get('/insights/health');
    return response.data;
  } catch (error) {
    console.error('[InsightsService] Health check failed:', error);
    throw error;
  }
};

/**
 * CACHE: Manter highlights em cache por 5min (padrão ArenaStats)
 */
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutos
let highlightsCache = null;
let highlightsCacheTime = null;

export const getWeeklyHighlightsCached = async (params = {}) => {
  const now = Date.now();
  
  // Se cache válido, retornar
  if (highlightsCache && highlightsCacheTime && (now - highlightsCacheTime < CACHE_DURATION)) {
    console.log('[InsightsService] Retornando highlights do cache');
    return highlightsCache;
  }
  
  // Buscar dados frescos
  const data = await getWeeklyHighlights(params);
  highlightsCache = data;
  highlightsCacheTime = now;
  
  return data;
};

export default {
  getWeeklyHighlights,
  getWeeklyHighlightsCached,
  getRecordProgression,
  getDominanceAnalysis,
  getRelayCorrection,
  getCreatorSpotlight,
  healthCheck
};
